import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from 'antd';
import { PRIVACY_POLICY_PATH, USER_AGREEMENT_PATH } from '@/features/auth/model/agreementLinks';
/**
 * 在新标签页打开协议正文页。
 *
 * 正文是站内路由页：既满足「看正文而不是下载文件」，又不会让用户离开尚未填完的登录表单。
 * @param path 协议正文页路径。
 */
function openAgreement(path) {
    window.open(path, '_blank', 'noopener,noreferrer');
}
/**
 * 渲染「我已阅读并同意《用户协议》和《隐私政策》」勾选行，置于登录按钮上方。
 *
 * 勾选框与协议文案**并列而非嵌套**：协议链接是独立按钮，点击时不会连带切换勾选状态。
 * 勾选状态由登录弹窗持有并在两个登录页签间共享，切换页签不会丢失。
 */
export function AgreementField(props) {
    return (_jsxs("div", { className: "auth-agreement", children: [_jsx(Checkbox, { className: "auth-agreement__check", checked: props.accepted, onChange: (event) => {
                    props.onAcceptedChange(event.target.checked);
                } }), _jsxs("span", { className: "auth-agreement__text", children: ["\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F", _jsx("button", { className: "auth-agreement__link", type: "button", onClick: () => {
                            openAgreement(USER_AGREEMENT_PATH);
                        }, children: "\u300A\u7528\u6237\u534F\u8BAE\u300B" }), "\u548C", _jsx("button", { className: "auth-agreement__link", type: "button", onClick: () => {
                            openAgreement(PRIVACY_POLICY_PATH);
                        }, children: "\u300A\u9690\u79C1\u653F\u7B56\u300B" })] })] }));
}
